module.exports = __webpack_public_path__ + "img/popup-bg_GT.3a24dcf.png";